import { observable } from 'mobx'
import { auth, updateUser, getUser } from './firestorter'

class AuthStore {
    loggedIn = observable.box(false)
    user = observable.box(null)

    constructor() {
        const lsUser = localStorage.getItem('user')

        if (lsUser) {
            this.loggedIn.set(true)
            this.user.set(JSON.parse(lsUser))
        }

        this.authListener = auth.onAuthStateChanged(async (authUser) => {
            this.loggedIn.set(!!authUser)

            if (authUser) {
                let dbUser = await getUser(authUser.uid)

                const enhancedUserObj = Object.assign(authUser.toJSON(),dbUser)

                localStorage.setItem('user', JSON.stringify(enhancedUserObj))
                this.user.set(enhancedUserObj)

                // Update last login in the db
                updateUser(authUser.uid, authUser)
            }
            else {
                localStorage.removeItem('user')
                this.user.set(null)
            }
        })
    }

    // Local
    updateUser(params) {
        const updatedUserObj = Object.assign(this.user.toJSON(), params)
        this.user.set(updatedUserObj)

        // Update last login in the db
        updateUser(updatedUserObj.uid, params, true)
    }
}

const authStore = new AuthStore()

export function signOut() {
    return new Promise((resolve, reject) => {
        auth.signOut().then(res => {
            authStore.user.set(null)
            authStore.loggedIn.set(false)
            resolve()
        }).catch(err => {
            reject(err)
        })
    })

}

export default authStore